import SlotComponent from '../../../SlotComponent';

const SuccessState = ({ blockClass, SuccessState, ...rest }: any) => {
	if (!SuccessState)
		return (
			<p
				onClick={rest.onClickHandler}
				className={`defaultSuccessMessage ${blockClass ? `defaultSuccessMessage--${blockClass} vtex-store-newsletter-1-x-defaultSuccessMessage--${blockClass}` : ''} vtex-store-newsletter-1-x-defaultSuccessMessage `}
			>
				Obrigado!
			</p>
		);
	return <SlotComponent props={{ blockClass, ...SuccessState, ...rest }} />;
};

export default SuccessState;
